import { useEffect } from "react";

export function useDocumentMeta(
  title: string,
  description?: string,
  keywords?: string
) {
  useEffect(() => {
    document.title = title;
    const setMeta = (name: string, content?: string) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("keywords", keywords);
  }, [title, description, keywords]);
}